// eslint-disable-next-line import/no-extraneous-dependencies
import { handleActions } from 'redux-actions';

import * as Actions from './actions';

const initialState = {
  isGetScheduleBookStatisticRequest: false,
  isGetScheduleBookStatisticSuccess: false,
  isGetScheduleBookStatisticFailure: false,
  listScheduleBookStatistic: {},

  errorMessages: [],
};

const reducer = handleActions(
  {
    // #region: get list schedule book statistic
    [Actions.getScheduleBookStatisticRequest]: (state) => ({
      ...state,
      isGetScheduleBookStatisticRequest: true,
      isGetScheduleBookStatisticSuccess: false,
      isGetScheduleBookStatisticFailure: false,
    }),
    [Actions.getScheduleBookStatisticSuccess]: (state, { payload }) => ({
      ...state,
      isGetScheduleBookStatisticRequest: false,
      isGetScheduleBookStatisticSuccess: true,
      isGetScheduleBookStatisticFailure: false,
      listScheduleBookStatistic: payload,
    }),
    [Actions.getScheduleBookStatisticFailure]: (state, { payload }) => ({
      ...state,
      isGetScheduleBookStatisticRequest: false,
      isGetScheduleBookStatisticSuccess: false,
      isGetScheduleBookStatisticFailure: true,
      errorMessages: payload,
    }),
    // #endregion
  },
  initialState,
);

export default reducer;
